<template>
  <div class="user-select">
    <div class="dept-menu">
      <div class="crumb-container">
        <ul class="dept-breadcrumb">
          <li v-for="parent in department.departments_path" :key="parent.id">
            <span class="primary-color" @click="changeDept(parent.id)">{{parent.name}}</span>
            <Icon type="arrow-next"></Icon>
          </li>
          <li>{{department.name}}</li>
        </ul>
      </div>
      <div class="dept-list">
        <div class="dept-item" v-for="child in department.children" :key="child.id" @click="changeDept(child.id)">
          <div class="item-name ellipsis">{{child.name}}</div>
          <div class="item-meta ellipsis">{{child.user_count}}</div>
          <Icon type="arrow-next"></Icon>
        </div>
      </div>
    </div>
    <div class="empty-state" v-show="!userList.length">
      <svg-icon icon="empty-default" />
      <p>{{ (promptText && promptText.length > 0) ? promptText : $t('contact.empty.contact')}}</p>
    </div>
    <div v-show="userList.length" class="filter-bar" @click="handleCheckAll">
      <van-checkbox
        v-model="checkAll"
        shape="round"
        @click.stop="handleCheckAll"
        ref="checkAll"
      >
        {{$t('base.selectAll')}}
      </van-checkbox>
    </div>
    <contact-list
      v-show="userList.length"
      :list="userList"
      :entities="contactEntities"
      @select="selectItem"
      showCheckbox
    />
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import Icon from '../utils/Icon'
import ContactList from './ContactList'

export default {
  name: 'elect',
  i18n,
  components: {
    Icon,
    ContactList
  },
  props: {
    promptText: String,
    currentDepartment: Number,
    userList: Array,
    contactEntities: Object,
    department: Object,
    departmentVisible: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'currentDepartment',
    event: 'change-current-dept'
  },
  data () {
    return {
      checkAll: false
    }
  },
  created () {
  },
  methods: {
    onSrcoll () {
    },
    handleCheckAll () {
      this.$refs.checkAll.toggle()
      const value = !this.$refs.checkAll.value
      this.$emit('check-all-users', value)
    },
    toggleSearch () {
      this.toggleQuery('contactsearch')
      // this.showSearch = !this.showSearch
    },
    changeDept (department_id) {
      if (department_id) {
        this.$emit('change-current-dept', department_id)
      }
    },
    selectItem (item) {
      if (item.checked && this.checkAll) {
        this.$refs.checkAll.toggle()
        // this.checkAll = false
      }
      this.$emit('toggle-contact', item)
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.user-select {
  flex: 1 1 auto;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  & .select-list {
    overflow: initial;
    -webkit-overflow-scrolling: initial;
  }

  & .dept-menu {
    background: #fff;
    margin-bottom: 10px;

    & .dept-breadcrumb {
      color: var(--secondlyText);
      height: 40px;
      line-height: 40px;
      margin: 0 15px;
      overflow-x: auto;
      overflow-y: hidden;
      white-space: nowrap;

      & li {
        display: inline;
      }
    }

    & .dept-item {
      display: flex;
      border-top: 1px solid var(--sepLineColor);
      font-size: 16px;
      line-height: 50px;
      margin-left: 15px;
      padding-right: 15px;

      & .item-name {
        flex: 1 1 auto
      }

      & .item-meta {
        flex: 0 0 auto;
        color: var(--secondlyText);
      }

      & .icon-arrow-next {
        flex: 0 0 auto;
        color: var(--contentIcon);
        padding-left: 10px;
      }
    }
  }

  & .filter-bar {
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-bottom: 1px solid var(--sepLineColor);

    & .van-checkbox {
      margin-left: 15px;
    }
  }

  & .empty-state {
    color: var(--placeholderText);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
